import React from 'react';
import cn from 'classnames';

import SearchModel from 'coreClasses/search/SearchModel';
import {useSearchMgrInstance} from 'coreHooks';

import Content from 'brand/app/contentful/components/Content';
import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';

import {IBannerProps} from './IBanner';

import styles from './Banner.module.scss';

const Banner = ({content}: IBannerProps) => {
	const {cgid, isPrevPageLoaded} = useCategoryContext(true) || {};
	const searchMgr = useSearchMgrInstance();
	const searchModel: SearchModel = searchMgr.getStoredSearchModel();

	return (
		<div
			className={cn(
				'category-banner',
				styles['category-banner'],
				{
					['hidden']: !isPrevPageLoaded && cgid && searchModel.getLowestLoadedPageNumber() > 1
				}
			)}
		>
			<Content data={content} />
		</div>
	);
};

export default Banner;
